import $ from 'jquery';

function toHMM (i, full = false) {
    var sec_num = parseInt(i, 10),
        hours   = Math.floor(sec_num / 3600),
        minutes = Math.floor((sec_num - (hours * 3600)) / 60),
        separator = (full ? ':' : '-');
    
    if (minutes < 10) {
        minutes = '0' + minutes;
    }

    if (full || minutes) {
        return hours + separator + minutes;
    }
    return hours;
}

export function weekschema (context) {
    $('table.weekschema-full.editable').each(function () {
        var $table = $(this),
            isMouseDown = false,
            highlight = false,
            $linkedSchemas = $($table.attr('data-linked-weekschemas')),
            $target = $($table.attr('data-target')),
            $availabilityAtTarget = $($table.attr('data-target-availability-at')),
            eveningStartsAt = 17 * 3600;

        if ($target.is('[disabled]')) {
            $table.addClass('disabled');
        }
        
        if ($target.val()) {
            var ranges = [];
            try {
                ranges = JSON.parse($target.val());
            } catch (e) {}

            $(ranges).each(function (i, rangeStr) {
                var range = {
                    day: 0,
                    start: 0,
                    duration: 0,
                    title: ''
                };
                $(rangeStr.split(' ')).each(function (j, part) {
                    var definition = part.split('-');
                    range[definition[0]] = definition[0] === 'day' ? definition[1] : (definition[1]) * 3600 + (definition.length > 2 ? definition[2] * 60 : 0);
                });
                
                var time = range.start,
                    title = toHMM(range.start, ':') + ' - ' + toHMM(range.start + range.duration, ':')
                while (time < range.start + range.duration) {
                    $table.find('td[data-day="' + range.day + '"][data-hour="' + time + '"]').addClass('hour-highlighted').attr('title', title);
                    time += 1800;
                }
            });
        }

        $table.find('tbody td')
            .on('mousedown', function (e) {
                if ($target.is('[disabled]') || $(this).is('[disabled]')) {
                    return;
                }

                isMouseDown = true;
                highlight = !$(this).hasClass('hour-highlighted');
                if (highlight) {
                    $(this).closest('table').addClass('marking');
                    $(this).addClass('hour-highlighted').find('input').val(1);
                } else {
                    $(this).closest('table').addClass('unmarking');
                    $(this).removeClass('hour-highlighted').find('input').val(0);
                }
                return false;
            })
            .on('mouseover', function (e) {
                if ($target.is('[disabled]') || $(this).is('[disabled]')) {
                    return;
                }

                if (isMouseDown) {
                    if (highlight) {
                        $(this).addClass('hour-highlighted').find('input').val(1);
                    } else {
                        $(this).removeClass('hour-highlighted').find('input').val(0);
                    }
                }
            });

        var stopSelection = function (e) {
            e.stopPropagation();

            if ($target.is('[disabled]') || $(this).is('[disabled]')) {
                return;
            }

            var updated = !!isMouseDown;
            isMouseDown = false;

            $table.removeClass('marking unmarking');

            if (!updated) {
                return;
            }

            var ranges = [],
                cssClasses = [],
                availabilityAt = '',
                $tds = [];

            $table.find('td').removeAttr('title');

            for (var day = 1; day <= 5; day++) {
                var range = {
                        day: day,
                        start: 0,
                        end: 0,
                        duration: 0,
                        title: '',
                        cls: '',
                        cells: []
                    },
                    interval = 1800,
                    $td;

                $table.find('td.hour-highlighted[data-day="' + day + '"]').sort(function (a, b) {
                    return $(a).data('sort') > $(b).data('sort') ? 1 : -1;
                }).each(function () {
                    $td = $(this);
                    var day = $td.data('day'),
                        hour = $td.data('hour');

                    if (availabilityAt !== 'day') {
                        availabilityAt = hour < eveningStartsAt ? 'day' : 'evening';
                    }

                    if (range.start + range.duration === hour) {
                        // The td is part of a range
                        range.end = hour;
                        range.duration += interval;
                        range.cells.push($td);
                    } else if (range.start && range.duration) {
                        // The td is a new range
                        range.title = toHMM(range.start, ':') + ' - ' + toHMM(range.start + range.duration, ':');
                        range.cls = 'day-' + range.day + ' start-' + toHMM(range.start) + ' duration-' + toHMM(range.duration);
                        cssClasses.push(range.cls);
                        ranges.push(range);

                        // Start a new range
                        range = {
                            day: day,
                            start: hour,
                            end: hour + interval,
                            duration: interval,
                            title: '',
                            cls: '',
                            cells: [$td]
                        };
                    } else {
                        // The td is the start of a range
                        range = {
                            day: day,
                            start: hour,
                            end: hour + interval,
                            duration: interval,
                            title: '',
                            cls: '',
                            cells: [$td]
                        };
                    }
                });

                if (range.start && range.duration) {
                    range.title = toHMM(range.start, ':') + ' - ' + toHMM(range.start + range.duration, ':');
                    range.cls = 'day-' + range.day + ' start-' + toHMM(range.start) + ' duration-' + toHMM(range.duration);
                    range.cells.push($td);
                    cssClasses.push(range.cls);
                    ranges.push(range);
                }
            }

            $target.val(JSON.stringify(cssClasses));
            $availabilityAtTarget.val(availabilityAt);
            $linkedSchemas.empty();

            $(ranges).each(function (i, range) {
                var cls = 'day-' + range.day + ' start-' + toHMM(range.start) + ' duration-' + toHMM(range.duration);
                $linkedSchemas.append('<span class="' + cls + '" title="' + range.title + '"></span>');
                $(range.cells).each(function () {
                    $(this).attr('title', range.title);
                });
            });
        };

        $(document).on('mouseup', stopSelection);
        $table.on('mouseup', stopSelection);
    });
}

export default {weekschema};